<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <template v-if="detailsEtapes.length > 0">
          <template>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item, index) in detailsEtapes" :key="index">
                    <td>{{ item.ll_details_etapes }}</td>
                    <!--  <td>{{ item.id }}</td>-->
                    <td><typeDetails :item="item" /></td>
                    <td>
                      <v-btn
                        @click="goToStats(item)"
                        outlined
                        x-small
                        fab
                        dark
                        class="green mr-2"
                      >
                        <v-icon>mdi-database-export-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </template>

        <div v-else>
          Pas de Détails
        </div>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    typeDetails: require("@/components/typeDetails.vue").default,
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  created() {
    if (!this.$route.params.etape) {
      console.log("pas de paramètres", this.$route.params.bailleur);
      this.$router.go(-1);
    }
    this.GetAllTypeDetails();
    this.getDetailsEtape(this.$route.params.etape.id);
  },

  data() {
    return {
      detailsEtapes: [],
      idDetailEtape: null,
      ll_details_etapes: "",
      type_champ: null,
      detailsParcours: {},
      typeDetailEtape_selected: "",
      dialogDetailsEtape: false,
      dialogDeleteDetailsEtape: false,
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
    };
  },
  methods: {
    goToStats(detailEtape) {
      this.$router.push({
        path: "/superviseur/stats/statsCampagne",
        query: detailEtape,
      });
    },
    updateCreateDetailEtape() {
      let self = this;
      console.log("étape:", this.$route.params.etape);
      const etape = this.$route.params.etape;
      let uuid = this.$uuid.v4();

      var docRef = this.$firebase
        .firestore()
        .collection("activites")
        .doc(etape.parcours_id_parcours);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.detailsParcours = doc.data();

            //*** */

            const activite = self.detailsParcours;

            if (this.$refs.formDetailEtape.validate()) {
              if (!this.idDetailEtape) {
                console.log("Nouveau détail étape");

                const newIdEtape = {
                  etape_id_etape: etape.id,
                  ll_etape: etape.ll_etape,
                  typeChamp: this.typeDetailEtape_selected,
                  rang: etape.rang,
                  parcours_id_parcours: etape.parcours_id_parcours,
                  ll_details_etapes: this.ll_details_etapes,
                  type_champ: this.typeDetailEtape_selected.id,
                  abbr_parcours: activite.abbr_parcours,
                  description_parcours: activite.description_parcours,
                  ll_parcours: activite.ll_parcours,
                  ll_programme: activite.ll_programme,
                  ll_theme: activite.ll_theme,
                  programmes_id_programme: activite.programmes_id_programme,
                  themes_id_theme: activite.themes_id_theme,
                };
                //console.log(newIdEtape);
                // Add a new document in collection "detailEtapes"
                console.log(newIdEtape);
                this.$firebase
                  .firestore()
                  .collection("detailEtapes")
                  .doc(uuid)
                  .set(newIdEtape)
                  .then(function () {
                    console.log("newIdEtape successfully written!", newIdEtape);
                    self.idDetailEtape = null;
                    self.getDetailsEtape(etape.id);
                  })
                  .catch(function (error) {
                    console.error("Error writing newIdEtape: ", error);
                  });
              } else {
                // console.log("Edition de "), this.idDetailEtape;

                const updatedIdEtape = {
                  ll_details_etapes: this.ll_details_etapes,
                  type_champ: this.typeDetailEtape_selected.id,
                  typeChamp: this.typeDetailEtape_selected,
                };

                var DetailEtape = this.$firebase
                  .firestore()
                  .collection("detailEtapes")
                  .doc(self.idDetailEtape);
                DetailEtape.set(updatedIdEtape, { merge: true });
                self.getDetailsEtape(etape.id);
                self.idDetailEtape = null;
              }
            }
            this.dialogDetailsEtape = false;
            this.$refs.formDetailEtape.reset();

            //*** */
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    deleteDetailEtape(detailEtape) {
      let self = this;
      var texte =
        "Voulez vous effacer ce Détail :  <b>'" +
        detailEtape.ll_details_etapes +
        "'</b> ? <br/> <br/> <i>Les données comprenant ce détail ne seront pas supprimées et appraîtront toujours dans la base de données</i>";
      this.$confirm(texte).then((res) => {
        if (res) {
          //console.log(detailEtape)
          this.$firebase
            .firestore()
            .collection("detailEtapes")
            .doc(detailEtape.id)
            .delete()
            .then(() => {
              console.log(
                "détail  " +
                  detailEtape.ll_details_etapes +
                  " successfully deleted!"
              );
              self.getDetailsEtape(self.$route.params.etape.id);
            })
            .catch((error) => {
              console.error("Error removing détail étape: ", error);
            });
        }
      });
    },
    openDialogDetailEtape(detailEtape) {
      console.log("typeDetailEtape_selected:", detailEtape);
      this.idDetailEtape = detailEtape.id;
      this.ll_details_etapes = detailEtape.ll_details_etapes;
      this.typeDetailEtape_selected = detailEtape.typeChamp;
      this.dialogDetailsEtape = true;
    },
    goback() {
      const activite = {
        description_parcours: this.$route.params.etape.description_parcours,
        ll_theme: this.$route.params.etape.ll_theme,
        programmes_id_programme: this.$route.params.etape
          .programmes_id_programme,
        themes_id_theme: this.$route.params.etape.ll_theme,
        abbr_parcours: this.$route.params.etape.abbr_parcours,
        ll_parcours: this.$route.params.etape.ll_parcours,
        ll_programme: this.$route.params.etape.ll_programme,
        id: this.$route.params.etape.parcours_id_parcours,
      };

      //console.log(activite);
      this.$router.push({
        name: "organisation-etapes-id",
        params: { activite },
      });
    },
    getDetailsEtape(etapeId) {
      let self = this;
      self.detailsEtapes = [];
      this.$firebase
        .firestore()
        .collection("detailEtapes")
        .where("etape_id_etape", "==", etapeId.toString())
        .orderBy("rangDetailEtape")
        .get()
        .then((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              self.detailsEtapes.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "modified") {
              let obj = self.detailsEtapes.find(
                (search) => search.id === change.doc.id
              );
              obj = change.doc.data();
            }
            if (change.type === "removed") {
              /*   console.log("Removed : ", change.doc.data());
                            let obj = elems.find((search) => search.id === change.doc.id);
                            const index = elems.indexOf(obj);
                            Vue.delete(elems, index); */
              //deleteProjetsDeBailleurs
            }
          });
        });
    },
    closeDialog() {
      this.dialogDetailsEtape = false;
      //this.dialogDeleteProjet = false;
      this.$refs.formDetailEtape.reset();
    },
    ...mapActions({
      GetAllTypeDetails: "TypeDetailEtape/GetAll",
    }),
  },
  computed: {
    ...mapState({
      TypeDetailEtape: (state) => state.TypeDetailEtape.TypeDetailEtape,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
